export const initializeState = () => {
  return (dispatch) =>
    dispatch({
      type: 'INITIALIZE_STATE',
    });
};
